import React from "react";

// Renders the release-level "Release Notes" line immediately underneath the
// existing Product Requirement notes in the Quantity Grid. Renders nothing
// for null/undefined/whitespace-only values so no empty note or extra
// whitespace is ever added to the grid.
const ReleaseNotesLine = ({ releaseNotes }) => {
  if (typeof releaseNotes !== "string" || !releaseNotes.trim()) return null;

  return <div className="release-notes">{`* ${releaseNotes} `}</div>;
};

export default React.memo(ReleaseNotesLine);
